<template>
  <textarea
    class="fts-form-control"
    v-model="model"
    autocomplete="ftsTextArea"
    :rows="rows"
    @input="$emit('input')"
    @blur="$emit('blur')"
  />
</template>

<script>
export default {
  props: {
    item: Object,
    formData: Object,
    rows: {
      type: Number,
      default: 4
    }
  },
  data: () => ({
    resizeObserver: null,
  }),
  methods: {
    autosizeTextarea(el) {
      el.style.height = "auto";
      el.style.height = el.scrollHeight + "px";
      this.$emit('updateHeight', el.style.height);
    },
  },
  computed: {
    model: {
      get() {
        return this.formData[this.item.fieldName]
      },
      set(val) {
        this.$set(this.formData, this.item.fieldName, val)
      }
    }
  },
  watch: {
    model: {
      deep: true,
      handler(val, oldVal) {
        if (val !== oldVal && oldVal !== undefined) {
          this.$nextTick(() => {
            this.autosizeTextarea(this.$el)
          });
        }
      },
    },
  },
  mounted() {
    let prevWidth = 0;
    this.resizeObserver = new ResizeObserver(_.debounce((entries) => {
      try {
        const entry = entries.find(x => x.target ===this.$el);
        if (entry) {
          const currWidth = entry.target.scrollWidth;
          if (prevWidth !== currWidth) {
            this.autosizeTextarea(entry.target);
          }
          prevWidth = currWidth;
        }
      } catch(err) {
        console.warn("[DOMException]:ResizeObserver", err);
      }
    }, 500));

    this.$nextTick(() => {
      this.$el.setAttribute(
        "style",
        "height:" + this.$el.scrollHeight + "px;",
      );
      this.resizeObserver.observe(this.$el);
    });

    if (this.formData[this.item.fieldName] !== null &&  this.formData[this.item.fieldName] !== undefined)
      this.formData[this.item.fieldName] = this.formData[this.item.fieldName].trimEnd()
  },
  beforeDestroy() {
    this.resizeObserver.unobserve(this.$el);
  },
  render() {
    return this.$slots.default[0];
  },
};
</script>

<style lang="scss" scoped>
textarea {
  resize: none;
  overflow: hidden;
  transition: none !important;
}
</style>